import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Crown } from 'lucide-react';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/top-artist`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('auth_token') || ''}` } });

export const TopArtistSpotlight = () => {
  const [a, setA] = useState(null);
  useEffect(() => { axios.get(API).then(r => setA(r.data)).catch(() => {}); }, []);
  if (!a?.has_artist) return null;
  return (
    <section data-testid="top-artist-spotlight" className="px-5 py-10">
      <div className="max-w-5xl mx-auto rounded-2xl border border-yellow-400/30 bg-gradient-to-r from-yellow-500/10 via-transparent to-fuchsia-500/10 p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-5">
        <div className="w-14 h-14 rounded-full bg-yellow-400 text-black flex items-center justify-center shrink-0">
          <Crown className="w-7 h-7" />
        </div>
        <div className="flex-1">
          <p className="text-xs uppercase tracking-[0.3em] text-yellow-300">Top Artist of {a.month}</p>
          <h2 data-testid="top-artist-name" className="text-3xl sm:text-4xl font-black text-white mt-1">{a.artist_name}</h2>
          <p className="text-sm text-gray-300 mt-1">Most studio time this month. Next month's top artist gets a free hour + this spot.</p>
        </div>
        <Link to="/book" data-testid="top-artist-book-btn" className="px-6 py-3 rounded-full bg-yellow-400 text-black font-bold hover:bg-yellow-300 transition-colors text-center">Book your session</Link>
      </div>
    </section>
  );
};

export const LeaderboardRace = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/leaderboard`).then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const slots = [0, 1, 2].map(i => d.leaders[i]);
  return (
    <section data-testid="leaderboard-race" className="px-5 pb-10">
      <div className="max-w-5xl mx-auto rounded-2xl border border-fuchsia-500/30 bg-white/[0.03] p-6">
        <div className="flex flex-wrap items-end justify-between gap-2 mb-5">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-fuchsia-300">{d.month} race</p>
            <h2 className="text-base md:text-lg font-bold text-white">Top 3 artists this month. The top spender wins a FREE hour on the 1st.</h2>
          </div>
          <Link to="/book" data-testid="leaderboard-book-btn" className="text-sm font-bold text-yellow-300 hover:text-yellow-200 transition-colors">Claim a spot →</Link>
        </div>
        <div className="grid grid-cols-3 gap-3">
          {slots.map((l, i) => (
            <div key={i} data-testid={`leaderboard-rank-${i + 1}`}
              className={`rounded-xl p-4 text-center border ${i === 0 ? 'border-yellow-400/60 bg-yellow-400/10' : 'border-white/10 bg-black/30'}`}>
              <div className={`text-2xl font-black ${i === 0 ? 'text-yellow-300' : 'text-white'}`}>#{i + 1}</div>
              <div className="text-sm text-gray-300 mt-1">{l ? `${l.hours} hrs` : 'Open spot'}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const TopArtistNameForm = () => {
  const [me, setMe] = useState(null);
  const [name, setName] = useState('');
  useEffect(() => {
    if (!localStorage.getItem('auth_token')) return;
    axios.get(`${API}/me`, auth()).then(r => { setMe(r.data); setName(r.data.artist_name || ''); }).catch(() => {});
  }, []);
  if (!me?.is_winner) return null;
  const save = async () => {
    try {
      await axios.post(`${API}/name`, { artist_name: name }, auth());
      toast.success('Your name is on the homepage');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not save');
    }
  };
  return (
    <div data-testid="top-artist-name-form" className="rounded-lg border border-yellow-400/40 bg-yellow-400/10 p-3">
      <p className="text-sm text-yellow-100 font-semibold">You're Top Artist of {me.month}!</p>
      <p className="text-xs text-gray-300 mb-2">Type the artist name to show on our homepage.</p>
      <div className="flex gap-2">
        <input data-testid="top-artist-name-input" value={name} maxLength={40} onChange={e => setName(e.target.value)}
          className="flex-1 px-3 py-1.5 rounded-md bg-black/40 border border-yellow-400/30 text-white text-sm" placeholder="Artist name" />
        <button data-testid="top-artist-name-save" disabled={!name.trim()} onClick={save}
          className="px-3 py-1.5 rounded-md bg-yellow-400 text-black text-sm font-bold disabled:opacity-40">Save</button>
      </div>
    </div>
  );
};
